import { required, integer, minValue, helpers } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

export default function (formState) {
  return {
    form: {
      customer_name: {
        required: helpers.withMessage(i18n.global.t('Please enter customer name.'), required)
      },
      telephone: {
        required: helpers.withMessage(i18n.global.t('Please enter telephone.'), required)
      },
      branch_id: {
        required: helpers.withMessage(i18n.global.t('Please select branch.'), required)
      },
      table_id: {
        required: helpers.withMessage(i18n.global.t('Please select a table.'), required)
      },
      guests: {
        required: helpers.withMessage(i18n.global.t('Please enter number of guests.'), required),
        integer: helpers.withMessage(i18n.global.t('Please enter a valid number.'), integer),
        minValue: helpers.withMessage(i18n.global.t('Please enter a valid must be at least 1.'), minValue(1))
      },
      reservation_at: {
        required: helpers.withMessage(i18n.global.t('Please select reservation date and time.'), required)
      },
      state: {
        required: helpers.withMessage(i18n.global.t('Please enter.'), required)
      }
    }
  }
};
